var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFtxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 35,
    viewBox: "0 0 112 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1650_18080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8589 13.2471V18.0417H65.3897V22.8051H55.8589V30.2802H49.7515V8.48065H66.6852V13.2471H55.8589Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5365 13.3717H68.9048V8.48065H88.2442V13.3717H81.6436V30.2802H75.5365V13.3717Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.467 30.2802L99.995 23.5211L95.5842 30.2802H88.6133L96.4788 19.2559L88.9528 8.48065H95.8309L100.149 14.7727L104.406 8.48065H111.007L103.48 19.0068L111.5 30.2802H104.467Z",
    fill: "#131112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 35H21.0503V25.7005H11.8359V35Z",
    fill: "#84D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2255 12.8456H11.8359V22.1482H29.2255H32.3879V12.8487H29.2255V12.8456Z",
    fill: "#33BBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8359 5.24521e-05V9.29956H40.3796V5.24521e-05H11.8359Z",
    fill: "#11A9BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22.1482H9.7113V12.8456H0.5V22.1482Z",
    fill: "#33BBC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1650_18080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 35,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtxLogo);
export default __webpack_public_path__ + "static/media/ftx_logo.38d30834523ead81c370f02aad3c08ad.svg";
export { ForwardRef as ReactComponent };